module.exports = __webpack_public_path__ + "img/create.75fbbf59.jpg";